export const Colors = {
  GrayPallete: {
    grayOne: '#4F4F4F',
    grayTwo: '#828282',
    lightgray: '#F6F6F6',
    lightgrayTwo: '#D9D9D9',
    lightgrayThree: '#818181',
    lightGrayFour: '#ADADAD',
    lightGrayFive: '#FFFFFF',
  },
  RedPallete: {
    red: '#DD0B1C',
    redTwo: '#bb0413ff',
  },
  lightGray: '#EEEEEE',
  translucid: '#F6F6F6',
  GreenPallete: {
    greenOne: '#33BC47',
    greenTwo: '#75C3AA',
  },
  OrangePallete: {
    orange: '#FFA500',
    offers: '#FF8C00',
  },
  BluePallete: {
    blue: '#007BFF',
    lightblue: '#5BC0DE',
  },
  adviceBackground: '#FFF6E0',
};

export const OffersColor = '#FF8C00';
